module.exports = __webpack_public_path__ + "media/components/assets/icons/board/arrow_down_sharp-8af818a2e96e8f7885215741a92ff35c.svg";